import type { ReactNode } from 'react';
import { HelpTooltip } from '@gonfalon/launchpad-experimental/HelpTooltip';

interface EventFilterInfoTooltipProps {
  labelText?: string;
  children?: ReactNode;
}

// Shared help-tooltip trigger for the event-filter UI. The default copy matches the legacy
// (flag-off) MetricEventFilters usage so that path is unchanged; the flag-on two-bar QueryBuilder
// passes its own per-bar context-attribute / event-property descriptions.
// Uses the shared HelpTooltip (Focusable + role="button" trigger) so the tooltip trigger is a real
// interactive element — wrapping a non-interactive Icon in <Pressable> is an accessibility defect.
export const EventFilterInfoTooltip: React.FC<EventFilterInfoTooltipProps> = ({
  labelText = 'About event filters',
  children = 'Filter which events count toward this metric. Click the bar and pick an event property or context attribute to add a condition, then choose an operator and value. Combine conditions with AND or OR — only events matching every condition are included.',
}) => (
  <HelpTooltip labelText={labelText}>
    <>{children}</>
  </HelpTooltip>
);
